module.exports = require("./es-HN.d.ts");